// /signup, the site's "Start free" link (apps/site/src/config/links.ts): someone new signs up and
// goes through the first run (an organization on the trial, or on Free when their trial was
// used, D107; then its project). Someone already signed in goes straight on.
import { useQuery } from '@tanstack/react-query'
import { Navigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { meQuery } from '../api/queries'
import { EntryPage, EntryWait } from '../components/d'
import { useI18n } from '../i18n'
import { hostedSignInUrl } from './SignIn'

const DEV_SIGN_IN = import.meta.env.DEV || import.meta.env.VITE_DEV_SIGN_IN === 'true'
/** Where /signup leads once the person is signed in: home, which opens their organization. */
const TARGET = '/'

export function SignupPage() {
  const { t } = useI18n()
  const me = useQuery({ ...meQuery, throwOnError: false })
  const hosted = !DEV_SIGN_IN && me.isError
  useEffect(() => {
    // Production: the identity provider's own sign-up page, back here afterwards.
    if (hosted) window.location.replace(hostedSignInUrl('sign-up', TARGET))
  }, [hosted])
  if (me.data) return <Navigate to={TARGET} replace />
  if (me.isError && DEV_SIGN_IN)
    return <Navigate to="/sign-in" search={{ screen: 'sign-up', return_to: TARGET }} replace />
  return (
    <EntryPage>
      <EntryWait>{t('signup.opening')}</EntryWait>
    </EntryPage>
  )
}
